module.exports = __webpack_public_path__ + "logo512.1c9b7325b79fb43b9919d55779060086.png";